import { useHomeScreenPrompt } from '../hooks/useHomeScreenPrompt';
import { IconShare, CloseIcon } from './icons';
import './HomeScreenBanner.css';

export function HomeScreenBanner() {
  const { shouldShow, addToHome, dismiss } = useHomeScreenPrompt();

  if (!shouldShow) return null;

  return (
    <div className="home-banner">
      <span className="home-banner-icon" aria-hidden><IconShare size={24} /></span>
      <div className="home-banner-content">
        <div className="home-banner-title">На главный экран</div>
        <div className="home-banner-subtitle">Открывай одним тапом</div>
      </div>
      <button type="button" className="home-banner-add" onClick={addToHome}>
        Добавить
      </button>
      <button type="button" className="home-banner-close" onClick={dismiss} aria-label="Закрыть">
        <CloseIcon size={14} />
      </button>
    </div>
  );
}
